// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"UserExistingModal_modalContainer__wifkv","headerText":"UserExistingModal_headerText__4MEKa","headerError":"UserExistingModal_headerError__fEaXc"};